import React from "react";
import { ListItemText as MUIListItemText } from "@mui/material";

const ListItemText = ({ item }) => {
  const title = `${item.prefix}`;
  const primaryText = (
    <>
      <b>Prefix: </b> {title || "null"}
    </>
  );

  const secondaryText = `${item.description} - ${item.points}pts`;

  return (
    <MUIListItemText
      primary={primaryText}
      // secondary={secondaryText || "null"}
    />
  );
};

export default ListItemText;
